export default __webpack_public_path__ + "static/eng-2-41e86e92d4aba6e21df0685ff4046c2c.jpg";